# frozen_string_literal: true

module Engine
  module Game
    module G1858
    end
  end
end
